/* eslint-disable no-dupe-keys */
export default {
  charge_channel: {
    name: '充电渠道',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '渠道名',
      order_source_type: '订单来源类型',
      user_id: '充电用户',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    order_source_types: {
      ecmp: '我方App订单',
      evcs: '第三方App订单'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询渠道名'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    // 标题
    titles: {
      base_info: '基本信息'
    }
  }
}
